import { z } from 'zod';

import {
  zodContractPayloadBaseSchema,
  zodContractResponseSchema,
} from '../validations';

/**
 * A draft is started before the user picks a supplier, so the seller is
 * optional here only. The endpoint takes neither a status nor items.
 */
export const zodCreateDraftContractPayloadSchema = zodContractPayloadBaseSchema
  .omit({ status: true })
  .extend({ sellerCompanyId: z.uuid().nullish() });

export { zodContractResponseSchema as zodCreateDraftContractResponseSchema };
